export { default } from './LottieControl';
